import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import type { ParagraphBlock } from '../../types';
import { normalizeAgentMarkdown } from '../../utils/normalizeAgentMarkdown';

export interface ParagraphBlockViewProps {
  block: ParagraphBlock;
}

export function ParagraphBlockView({ block }: ParagraphBlockViewProps): React.ReactElement {
  const markdown = normalizeAgentMarkdown(block.text);
  return (
    <div
      data-testid="block-paragraph"
      className="text-[14px] font-normal leading-relaxed text-text-primary [&_strong]:font-semibold [&_code]:font-mono [&_code]:text-xs [&_code]:bg-surface-secondary [&_code]:px-1 [&_code]:py-0.5 [&_code]:rounded"
    >
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{markdown}</ReactMarkdown>
    </div>
  );
}
